// Imoprts
import { MDTTypePayloadTypeConfig } from "../interfaces/mdt-type-map.interface";

export const UPDATE_SELECTED_MDT_TYPE_CONFIG = 'UPDATE_SELECTED_MDT_TYPE_CONFIG';

export function currentMDTConfigReducer(state: MDTTypePayloadTypeConfig, action: any): MDTTypePayloadTypeConfig {
    switch (action.type) {
      case UPDATE_SELECTED_MDT_TYPE_CONFIG:
          return action.payload ?? state;
      default:
        return state;
    }
  }